// extracted by mini-css-extract-plugin
module.exports = {"propertyFeaturesBar":"rQWfI"};